import { Composable, Inject, Vue } from '@natureos/vue-facing-decorator';

import type { ApiResponse, ApiService } from '@/common/services/api.service-new';
import type {
  ReddCalculateRequest,
  ReddCalculateResponse,
  ReddGatherRequest,
  ReddGatherResponse,
} from './redd.types';

// REDD+ (VM0007) calculator service. Two POST endpoints under VITE_GEE_API:
// `/gather` does the (slow) Earth-Engine work once; `/calculate` is EE-free and
// re-callable on every input edit. See ~/.claude/contract/260624_reddplus_calculator.md.
@Composable()
export class useReddService extends Vue {
  @Inject()
  private readonly api!: ApiService;

  // POST /redd/vm0007/gather — project forest area, buffer deforestation rate,
  // area-weighted AGB, and the reference-area donut. Several seconds (EE).
  public async getReddGather(body: ReddGatherRequest): Promise<ApiResponse<ReddGatherResponse>> {
    return this.api.post<ReddGatherResponse>(
      `${import.meta.env.VITE_GEE_API}/redd/vm0007/gather`,
      body,
    );
  }

  // POST /redd/vm0007/calculate — pure VM0007 per-year projection. Sub-second;
  // call on every discount / EI / crediting-period edit without re-gathering.
  public async getReddCalculate(
    body: ReddCalculateRequest,
  ): Promise<ApiResponse<ReddCalculateResponse>> {
    return this.api.post<ReddCalculateResponse>(
      `${import.meta.env.VITE_GEE_API}/redd/vm0007/calculate`,
      body,
    );
  }
}
